import React from 'react'
import { ReactComponent } from './add.svg'
import { MergeReactElementProps } from '@komune-io/g2-utils'

interface AddIconProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', AddIconProps>

export const AddIcon = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#828282' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
